import styled from "styled-components";

const LayerContent = styled.div`
  padding-bottom: calc(1em - env(safe-area-inset-bottom));
  padding-top: calc(1em + env(safe-area-inset-top));
  max-height: calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  overflow: scroll
`

export default LayerContent
